import * as React from 'react';
import classnames from 'classnames';
import {
  Button,
  Card as DesignSystemCard,
  HStack,
  Typography,
  VStack,
} from '@vivaahealth/design-system';

import greenCheckCircle from '../../assets/green-check-circle.svg';

import styles from './index.module.css';

interface Props {
  title: string;
  description: string;
  callToActionText: string;
  onClick?: () => void;
  dismissed?: boolean;
  completed?: boolean;
}

export const Card: React.FC<Props> = ({
  title,
  description,
  callToActionText,
  onClick,
  completed,
}) => {
  return (
    <DesignSystemCard>
      <DesignSystemCard.Header>
        <HStack justifyContent="space-between" width="100%" alignItems="center">
          <HStack alignItems="center" gap={8}>
            {completed && (
              <img
                alt="success"
                className={classnames(styles.SuccessIcon)}
                src={greenCheckCircle}
              />
            )}
            <Typography
              variant="title-large"
              bold
              color={completed ? 'secondary' : undefined}
            >
              {title}
            </Typography>
          </HStack>
        </HStack>
      </DesignSystemCard.Header>

      {completed ? null : (
        <DesignSystemCard.Body>
          <VStack gap={16}>
            <Typography variant="paragraph-medium">{description}</Typography>
            <Button onClick={onClick} variant="primary" fullWidth>
              {callToActionText}
            </Button>
          </VStack>
        </DesignSystemCard.Body>
      )}
    </DesignSystemCard>
  );
};
